import * as _readline2 from "readline";

var _readline = "default" in _readline2 ? _readline2.default : _readline2;

import * as _chalk2 from "chalk";

var _chalk = "default" in _chalk2 ? _chalk2.default : _chalk2;

import * as _cliCursor2 from "cli-cursor";

var _cliCursor = "default" in _cliCursor2 ? _cliCursor2.default : _cliCursor2;

import * as _cliSpinners2 from "cli-spinners";

var _cliSpinners = "default" in _cliSpinners2 ? _cliSpinners2.default : _cliSpinners2;

import * as _logSymbols2 from "log-symbols";

var _logSymbols = "default" in _logSymbols2 ? _logSymbols2.default : _logSymbols2;

import * as _stripAnsi2 from "strip-ansi";

var _stripAnsi = "default" in _stripAnsi2 ? _stripAnsi2.default : _stripAnsi2;

import * as _wcwidth2 from "wcwidth";

var _wcwidth = "default" in _wcwidth2 ? _wcwidth2.default : _wcwidth2;

import * as _isInteractive2 from "is-interactive";

var _isInteractive = "default" in _isInteractive2 ? _isInteractive2.default : _isInteractive2;

import * as _isUnicodeSupported2 from "is-unicode-supported";

var _isUnicodeSupported = "default" in _isUnicodeSupported2 ? _isUnicodeSupported2.default : _isUnicodeSupported2;

import * as _bl2 from "bl";

var _bl = "default" in _bl2 ? _bl2.default : _bl2;

import _process from "process";
var exports = {};
var process = _process;
const readline = _readline;
const chalk = _chalk;
const cliCursor = _cliCursor;
const cliSpinners = _cliSpinners;
const logSymbols = _logSymbols;
const stripAnsi = _stripAnsi;
const wcwidth = _wcwidth;
const isInteractive = _isInteractive;
const isUnicodeSupported = _isUnicodeSupported;
const {
  BufferListStream
} = _bl;
const TEXT = Symbol("text");
const PREFIX_TEXT = Symbol("prefixText");
const ASCII_ETX_CODE = 3; // Ctrl+C emits this code

class StdinDiscarder {
  constructor() {
    this.requests = 0;
    this.mutedStream = new BufferListStream();
    this.mutedStream.pipe(process.stdout);
    const self = this; // eslint-disable-line unicorn/no-this-assignment

    this.ourEmit = function (event, data, ...args) {
      const {
        stdin
      } = process;

      if (self.requests > 0 || stdin.emit === self.ourEmit) {
        if (event === "keypress") {
          // Fixes readline behavior
          return;
        }

        if (event === "data" && data.includes(ASCII_ETX_CODE)) {
          process.emit("SIGINT");
        }

        Reflect.apply(self.oldEmit, this, [event, data, ...args]);
      } else {
        Reflect.apply(process.stdin.emit, this, [event, data, ...args]);
      }
    };
  }

  start() {
    this.requests++;

    if (this.requests === 1) {
      this.realStart();
    }
  }

  stop() {
    if (this.requests <= 0) {
      throw new Error("`stop` called more times than `start`");
    }

    this.requests--;

    if (this.requests === 0) {
      this.realStop();
    }
  }

  realStart() {
    // No known way to make it work reliably on Windows
    if (process.platform === "win32") {
      return;
    }

    this.rl = readline.createInterface({
      input: process.stdin,
      output: this.mutedStream
    });
    this.rl.on("SIGINT", () => {
      if (process.listenerCount("SIGINT") === 0) {
        process.emit("SIGINT");
      } else {
        this.rl.close();
        process.kill(process.pid, "SIGINT");
      }
    });
  }

  realStop() {
    if (process.platform === "win32") {
      return;
    }

    this.rl.close();
    this.rl = undefined;
  }

}

let stdinDiscarder;

class Ora {
  constructor(options) {
    if (!stdinDiscarder) {
      stdinDiscarder = new StdinDiscarder();
    }

    if (typeof options === "string") {
      options = {
        text: options
      };
    }

    this.options = {
      text: "",
      color: "cyan",
      stream: process.stderr,
      discardStdin: true,
      ...options
    };
    this.spinner = this.options.spinner;
    this.color = this.options.color;
    this.hideCursor = this.options.hideCursor !== false;
    this.interval = this.options.interval || this.spinner.interval || 100;
    this.stream = this.options.stream;
    this.id = undefined;
    this.isEnabled = typeof this.options.isEnabled === "boolean" ? this.options.isEnabled : isInteractive({
      stream: this.stream
    });
    this.isSilent = typeof this.options.isSilent === "boolean" ? this.options.isSilent : false; // Set *after* `this.stream`

    this.text = this.options.text;
    this.prefixText = this.options.prefixText;
    this.linesToClear = 0;
    this.indent = this.options.indent;
    this.discardStdin = this.options.discardStdin;
    this.isDiscardingStdin = false;
  }

  get indent() {
    return this._indent;
  }

  set indent(indent = 0) {
    if (!(indent >= 0 && Number.isInteger(indent))) {
      throw new Error("The `indent` option must be an integer from 0 and up");
    }

    this._indent = indent;
  }

  _updateInterval(interval) {
    if (interval !== undefined) {
      this.interval = interval;
    }
  }

  get spinner() {
    return this._spinner;
  }

  set spinner(spinner) {
    this.frameIndex = 0;

    if (typeof spinner === "object") {
      if (spinner.frames === undefined) {
        throw new Error("The given spinner must have a `frames` property");
      }

      this._spinner = spinner;
    } else if (!isUnicodeSupported()) {
      this._spinner = cliSpinners.line;
    } else if (spinner === undefined) {
      // Set default spinner
      this._spinner = cliSpinners.dots;
    } else if (spinner !== "default" && cliSpinners[spinner]) {
      this._spinner = cliSpinners[spinner];
    } else {
      throw new Error(`There is no built-in spinner named '${spinner}'. See https://github.com/sindresorhus/cli-spinners/blob/main/spinners.json for a full list.`);
    }

    this._updateInterval(this._spinner.interval);
  }

  get text() {
    return this[TEXT];
  }

  set text(value) {
    this[TEXT] = value;
    this.updateLineCount();
  }

  get prefixText() {
    return this[PREFIX_TEXT];
  }

  set prefixText(value) {
    this[PREFIX_TEXT] = value;
    this.updateLineCount();
  }

  get isSpinning() {
    return this.id !== undefined;
  }

  getFullPrefixText(prefixText = this[PREFIX_TEXT], postfix = " ") {
    if (typeof prefixText === "string") {
      return prefixText + postfix;
    }

    if (typeof prefixText === "function") {
      return prefixText() + postfix;
    }

    return "";
  }

  updateLineCount() {
    const columns = this.stream.columns || 80;
    const fullPrefixText = this.getFullPrefixText(this.prefixText, "-");
    this.lineCount = 0;

    for (const line of stripAnsi(fullPrefixText + "--" + this[TEXT]).split("\n")) {
      this.lineCount += Math.max(1, Math.ceil(wcwidth(line) / columns));
    }
  }

  get isEnabled() {
    return this._isEnabled && !this.isSilent;
  }

  set isEnabled(value) {
    if (typeof value !== "boolean") {
      throw new TypeError("The `isEnabled` option must be a boolean");
    }

    this._isEnabled = value;
  }

  get isSilent() {
    return this._isSilent;
  }

  set isSilent(value) {
    if (typeof value !== "boolean") {
      throw new TypeError("The `isSilent` option must be a boolean");
    }

    this._isSilent = value;
  }

  frame() {
    const {
      frames
    } = this.spinner;
    let frame = frames[this.frameIndex];

    if (this.color) {
      frame = chalk[this.color](frame);
    }

    this.frameIndex = ++this.frameIndex % frames.length;
    const fullPrefixText = typeof this.prefixText === "string" && this.prefixText !== "" ? this.prefixText + " " : "";
    const fullText = typeof this.text === "string" ? " " + this.text : "";
    return fullPrefixText + frame + fullText;
  }

  clear() {
    if (!this.isEnabled || !this.stream.isTTY) {
      return this;
    }

    for (let i = 0; i < this.linesToClear; i++) {
      if (i > 0) {
        this.stream.moveCursor(0, -1);
      }

      this.stream.clearLine();
      this.stream.cursorTo(this.indent);
    }

    this.linesToClear = 0;
    return this;
  }

  render() {
    if (this.isSilent) {
      return this;
    }

    this.clear();
    this.stream.write(this.frame());
    this.linesToClear = this.lineCount;
    return this;
  }

  start(text) {
    if (text) {
      this.text = text;
    }

    if (this.isSilent) {
      return this;
    }

    if (!this.isEnabled) {
      if (this.text) {
        this.stream.write(`- ${this.text}\n`);
      }

      return this;
    }

    if (this.isSpinning) {
      return this;
    }

    if (this.hideCursor) {
      cliCursor.hide(this.stream);
    }

    if (this.discardStdin && process.stdin.isTTY) {
      this.isDiscardingStdin = true;
      stdinDiscarder.start();
    }

    this.render();
    this.id = setInterval(this.render.bind(this), this.interval);
    return this;
  }

  stop() {
    if (!this.isEnabled) {
      return this;
    }

    clearInterval(this.id);
    this.id = undefined;
    this.frameIndex = 0;
    this.clear();

    if (this.hideCursor) {
      cliCursor.show(this.stream);
    }

    if (this.discardStdin && process.stdin.isTTY && this.isDiscardingStdin) {
      stdinDiscarder.stop();
      this.isDiscardingStdin = false;
    }

    return this;
  }

  succeed(text) {
    return this.stopAndPersist({
      symbol: logSymbols.success,
      text
    });
  }

  fail(text) {
    return this.stopAndPersist({
      symbol: logSymbols.error,
      text
    });
  }

  warn(text) {
    return this.stopAndPersist({
      symbol: logSymbols.warning,
      text
    });
  }

  info(text) {
    return this.stopAndPersist({
      symbol: logSymbols.info,
      text
    });
  }

  stopAndPersist(options = {}) {
    if (this.isSilent) {
      return this;
    }

    const prefixText = options.prefixText || this.prefixText;
    const text = options.text || this.text;
    const fullText = typeof text === "string" ? " " + text : "";
    this.stop();
    this.stream.write(`${this.getFullPrefixText(prefixText, " ")}${options.symbol || " "}${fullText}\n`);
    return this;
  }

}

const oraFactory = function (options) {
  return new Ora(options);
};

exports = oraFactory;

exports.promise = (action, options) => {
  // eslint-disable-next-line promise/prefer-await-to-then
  if (typeof action.then !== "function") {
    throw new TypeError("Parameter `action` must be a Promise");
  }

  const spinner = new Ora(options);
  spinner.start();

  (async () => {
    try {
      await action;
      spinner.succeed();
    } catch {
      spinner.fail();
    }
  })();

  return spinner;
};

export default exports;
export const promise = exports.promise;